// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.spinner-text {
  color: #434C63;
}

.points {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  display: block;
  margin: 15px auto;
  position: relative;
  color: #434C63;
  box-sizing: border-box;
  animation: animatedLoader 2s linear infinite;
}

@keyframes animatedLoader {
  0% {
    box-shadow: 14px 0 0 -2px, 38px 0 0 -2px, -14px 0 0 -2px, -38px 0 0 -2px;
  }
  25% {
    box-shadow: 14px 0 0 -2px, 38px 0 0 -2px, -14px 0 0 -2px, -38px 0 0 2px;
  }
  50% {
    box-shadow: 14px 0 0 -2px, 38px 0 0 -2px, -14px 0 0 2px, -38px 0 0 -2px;
  }
  75% {
    box-shadow: 14px 0 0 2px, 38px 0 0 -2px, -14px 0 0 -2px, -38px 0 0 -2px;
  }
  100% {
    box-shadow: 14px 0 0 -2px, 38px 0 0 2px, -14px 0 0 -2px, -38px 0 0 -2px;
  }
}

.circle {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  position: relative;
  animation: rotate 1s linear infinite
}

.circle::before,
.circle::after {
  content: "";
  box-sizing: border-box;
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 5px solid #FFF;
  animation: prixClipFix 2s linear infinite;
}

.circle::after {
  transform: rotate3d(90, 90, 0, 180deg);
  border-color: #ffdd00;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg)
  }
  100% {
    transform: rotate(360deg)
  }
}

@keyframes prixClipFix {
  0% {
    clip-path: polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0)
  }
  50% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 0, 100% 0, 100% 0)
  }
  75%, 100% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 100% 100%, 100% 100%)
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Spinner/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE;IACE,wEAAwE;EAC1E;EACA;IACE,uEAAuE;EACzE;EACA;IACE,uEAAuE;EACzE;EACA;IACE,uEAAuE;EACzE;EACA;IACE,uEAAuE;EACzE;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB;AACF;;AAEA;;EAEE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE;IACE;EACF;EACA;IACE;EACF;AACF;;AAEA;EACE;IACE;EACF;EACA;IACE;EACF;EACA;IACE;EACF;AACF","sourcesContent":[".spinner-block {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.spinner-text {\n  color: #434C63;\n}\n\n.points {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  display: block;\n  margin: 15px auto;\n  position: relative;\n  color: #434C63;\n  box-sizing: border-box;\n  animation: animatedLoader 2s linear infinite;\n}\n\n@keyframes animatedLoader {\n  0% {\n    box-shadow: 14px 0 0 -2px, 38px 0 0 -2px, -14px 0 0 -2px, -38px 0 0 -2px;\n  }\n  25% {\n    box-shadow: 14px 0 0 -2px, 38px 0 0 -2px, -14px 0 0 -2px, -38px 0 0 2px;\n  }\n  50% {\n    box-shadow: 14px 0 0 -2px, 38px 0 0 -2px, -14px 0 0 2px, -38px 0 0 -2px;\n  }\n  75% {\n    box-shadow: 14px 0 0 2px, 38px 0 0 -2px, -14px 0 0 -2px, -38px 0 0 -2px;\n  }\n  100% {\n    box-shadow: 14px 0 0 -2px, 38px 0 0 2px, -14px 0 0 -2px, -38px 0 0 -2px;\n  }\n}\n\n.circle {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  position: relative;\n  animation: rotate 1s linear infinite\n}\n\n.circle::before,\n.circle::after {\n  content: \"\";\n  box-sizing: border-box;\n  position: absolute;\n  inset: 0;\n  border-radius: 50%;\n  border: 5px solid #FFF;\n  animation: prixClipFix 2s linear infinite;\n}\n\n.circle::after {\n  transform: rotate3d(90, 90, 0, 180deg);\n  border-color: #ffdd00;\n}\n\n@keyframes rotate {\n  0% {\n    transform: rotate(0deg)\n  }\n  100% {\n    transform: rotate(360deg)\n  }\n}\n\n@keyframes prixClipFix {\n  0% {\n    clip-path: polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0)\n  }\n  50% {\n    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 0, 100% 0, 100% 0)\n  }\n  75%, 100% {\n    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 100% 100%, 100% 100%)\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
